import { FormDropdown } from '@shared/components/dynamic-form/models/form-dropdown';
import { DateInput } from '@shared/components/dynamic-form/models';
import { futureDateValidator } from '@shared/validators/forms/futureDate';
const countOptions = () => {
  const options = [];
  for (let i = 2; i <= 24; i++) {
    options.push({ label: i.toString(), value: i });
  }
  return options;
};
export const propostalForm = [
  new FormDropdown({
    key: 'channel',
    type: 'dropdown',
    required: true,
    label: 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.FORM.CHANNEL.LABEL',
    options: [],
    multi: false,
    filter: true,
    readonly: false,
  }),

  new FormDropdown({
    key: 'instalments',
    type: 'dropdown',
    required: true,
    label: 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.FORM.CHANNEL.INSTALMENTS',
    options: countOptions(),
    value: 1,
    multi: false,
    filter: true,
    readonly: false,
  }),

  new DateInput({
    key: 'expirationAt',
    type: 'date',
    label: 'DATA.MODULES.SHARED.COMPONENTS.SEND_PAYMENT_AGREEMENT.FORM.CHANNEL.EXPIRES_72H',
    value: new Date(Date.now() + 72 * 60 * 60 * 1000),
    placeholder: 'dd/mm/yyyy',
    editable: true,
    disabled: false,
    required: true,
    validators: [futureDateValidator()],
  }),
];
